/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { urlNegocioCoimpresores, middlewareCoimpresores } from '../../conexiones';
import IEtiqueta from './entidades/etiqueta';

export default class ModeloEtiquetas {
    public async consultarEtiquetas() {
        return manejadorRest<IRespuesta<IEtiqueta>>(() => middlewareCoimpresores.get(`Etiqueta?idEtiqueta=0`), true);
    }
}
